import React, { useEffect, useMemo, useState } from "react";
import { Sidebar } from "@solidwhite/react-ui-components";
import Title from "./Title";
import CarouselWrapper from "./CarouselWrapper";
import AccordionWrapper from "./AccordionWrapper";
import useContent from "../../../hooks/useContent";
import store from "../../../appStore";
import { useSnapshot } from "valtio";
import Button from "../Button";
import { useTranslation } from "react-i18next";
import useAuth from "../../../hooks/useAuth";
import { useSynchronizedState } from "@solidwhite/multiuser";

const SideBar = ({ visible = false, contentId = "" }) => {
  const [content] = useContent(contentId);
  const { autoPlay } = useSnapshot(store);
  // console.log(content);
  const [showSidebar, setShowSidebar] = useState(false);
  const [sidebarToggle, setSidebarToggle] = useSynchronizedState(`sidebartoggel_${contentId}`, false);

  const { t } = useTranslation();
  const { currentUser } = useAuth();

  const hasContent = useMemo(() => {
    if (content == undefined) return false;

    return content.benefitsTranslationKey != "" || content.featuresTranslationKey != "" || content.titleTranslationKey != "";
  }, [content]);

  useEffect(() => {
    if (hasContent) {
      setShowSidebar(true);
      store.sideBarVisible = true;
    }
  }, [hasContent]);

  useEffect(() => {
    if (!visible) {
      setShowSidebar(false);
    } else if (hasContent) {
      setShowSidebar(true);
    }
  }, [visible, hasContent]);

  useEffect(() => {
    if (sidebarToggle) {
      store.sideBarToggle = true;
    } else {
      store.sideBarToggle = false;
    }
  }, [sidebarToggle]);

  const handleSharepointButtonClick = () => {
    window.open(t("BUTTON_SHAREPOINT_URL"), "_blank").focus();
  };

  const showSharepointButton = useMemo(() => {
    return t("BUTTON_SHAREPOINT_URL") !== "BUTTON_SHAREPOINT_URL";
  }, []);

  return (
    <div style={{ pointerEvents: "auto" }}>
      <Sidebar
        backgroundColor="#000"
        visible={showSidebar && !autoPlay}
        heightSideBar="100vh"
        right={true}
        bottom={true}
        sidebarToggle={sidebarToggle}
        setSidebarToggle={() => setSidebarToggle(!sidebarToggle)}
        arrowColor="#3EBA7C"
      >
        <CarouselWrapper content={content} contentId={contentId} showSidebar={true} />
        <Title content={content} showSidebar={true} />
        <AccordionWrapper content={content} showSidebar={true} contentId={contentId} />
        {currentUser != null && (
          <div
            style={{
              padding: "1.2vw",
              display: showSharepointButton ? "block" : "none",
            }}
          >
            <Button onClick={handleSharepointButtonClick} textId="BUTTON_SHAREPOINT" />
          </div>
        )}
      </Sidebar>
    </div>
  );
};

export const SideBarHider = () => {
  useEffect(() => {
    store.sideBarVisible = false;
  }, []);

  return null;
};

export default SideBar;
